import { Menu, Sparkles } from "lucide-react";

/**
 * Top bar — Brief 2 §1.
 * Left: the section title (passed in by the active page).
 * Right: "Talk to Nerea" CTA (opens the Nerea modal).
 * Mobile: a hamburger that opens the sidebar drawer.
 */
export default function TopBar({ title, onOpenSupport, onOpenSidebar }) {
  return (
    <header
      data-testid="app-topbar"
      className="sticky top-0 z-30 h-16 flex items-center justify-between gap-3 px-5 sm:px-8 border-b border-white/[0.06] bg-[#0a0a0a]/85 backdrop-blur-2xl"
    >
      <div className="flex items-center gap-3 min-w-0">
        <button
          type="button"
          onClick={onOpenSidebar}
          data-testid="app-topbar-menu"
          aria-label="Open menu"
          className="md:hidden h-9 w-9 rounded-xl flex items-center justify-center border border-white/[0.08] bg-white/[0.02] text-white hover:bg-white/[0.06] transition-colors shrink-0"
        >
          <Menu className="h-4 w-4" />
        </button>
        <h1
          data-testid="app-topbar-title"
          className="font-display text-[19px] sm:text-[22px] font-semibold tracking-tight text-white truncate"
        >
          {title}
        </h1>
      </div>

      <button
        type="button"
        onClick={onOpenSupport}
        data-testid="app-topbar-nerea-btn"
        className="group relative inline-flex items-center gap-1.5 rounded-full border border-[#00E5FF]/30 bg-[#00E5FF]/[0.06] hover:bg-[#00E5FF]/[0.12] hover:border-[#00E5FF]/55 text-white transition-colors px-3.5 sm:px-4 py-1.5 sm:py-2 text-[12.5px] sm:text-[13px] font-medium shrink-0"
      >
        <Sparkles className="h-3.5 w-3.5 text-[#00E5FF]" />
        <span className="hidden sm:inline">Talk to Nerea</span>
        <span className="sm:hidden">Nerea</span>
      </button>
    </header>
  );
}
